import { render, staticRenderFns } from "./MetaFieldSelector.vue?vue&type=template&id=b27c0236&scoped=true&"
import script from "./MetaFieldSelector.vue?vue&type=script&lang=js&"
export * from "./MetaFieldSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27c0236",
  null
  
)

export default component.exports